import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './../style/Team.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox' // Добавлен импорт

class Team extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.state = {
      activeIndex: 0,
      lightboxController: { // Добавлено состояние для лайтбокса
        toggler: false,
        slide: 1
      }
    }
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  // Добавлен обработчик для открытия лайтбокса
  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data, margin } = this.props
    const { lightboxController } = this.state // Получаем состояние лайтбокса

    return (
      <section className={`${styles.section} ${styles[margin]}`}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.text || ``}
            className={styles.title}
          />
          
          {/* Добавлен компонент лайтбокса */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={data?.list.map(item => item.full || item.image)}
            slide={lightboxController.slide}
          />

          <div className={styles.swiper_container}>
            <Swiper
              ref={this.swiperRef}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={2}
              loop={true}
              onSlideChange={this.handleSlideChange}
              onSwiper={(swiper) => {
                // Инициализация активного индекса при загрузке
                this.setState({ activeIndex: swiper.realIndex })
              }}
              breakpoints={{
                768: {
                  slidesPerView: 3
                },
                992: {
                  slidesPerView: 4
                },
                1202: {
                  slidesPerView: 5
                }
              }}
            >
              {data?.list.map( ( slyde, index ) => (
                <SwiperSlide key={index}>
                  <div className={styles.slyde}>
                    <div className={styles.slyde_topline}>
                      <div>GOODWIN</div>
                      <div className={styles.slyde_topline_sep}></div>
                      <div>{this.formatSlideNumber( index )}</div>
                    </div>
                    {/* Добавлен обработчик клика для открытия лайтбокса */}
                    <div onClick={() => this.openLightbox(index)} style={{cursor: 'pointer'}}>
                      <Image className={styles.slyde_image} src={slyde?.image} width={228} height={295} alt={slyde?.name} />
                    </div>
                    <div className={styles.slyde_text}>{slyde?.text}</div>
                    <div className={styles.slyde_name}>{slyde?.name}</div>
                  </div>
                </SwiperSlide>
              ) )}
            </Swiper>
            <div className={styles.slydenav_btns}>
              <div></div>
              <div className={styles.slydenav_btn} onClick={this.nextSlide}>
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                </svg>
              </div>
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Team.propTypes = {
  data: PropTypes.object,
  margin: PropTypes.string
}

Team.defaultProps = {
  data: {},
  margin: `y`
}

export default Team